import React from 'react';
import { Layout } from '../components/Layout';
import { Button } from '../components/ui/Button';
import { Link } from 'react-router-dom';
import {Clock, Users, Dumbbell, MapPin, Star, Award, Heart, Zap} from 'lucide-react';

const Club = () => {
  return (
    <Layout>
      {/* Hero Section */}
      <section className="relative h-[60vh] flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0 z-0">
          <img 
            src="https://static.lumi.new/ed/edf9be7aaba7bd064ce6fae4a3a43c76.webp" 
            alt="No Limit Fitness Écrouves" 
            className="w-full h-full object-cover opacity-50"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black via-black/70 to-black" />
        </div>
        
        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-5xl md:text-7xl font-black text-white mb-6 tracking-tighter italic">
            LE <span className="text-nolimit-red">CLUB</span>
          </h1>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto leading-relaxed">
            Votre centre de remise en forme de référence près de Toul
          </p>
        </div>
      </section>

      {/* Introduction Section */}
      <section className="py-20 bg-black">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
            <div>
              <h2 className="text-4xl font-black italic text-white mb-6">
                DÉCOUVREZ NOTRE CLUB DE SPORT <span className="text-nolimit-red">PRÈS DE TOUL</span>
              </h2>
              <p className="text-gray-300 text-lg mb-6 leading-relaxed">
                Vous êtes décidé à vous mettre au sport dans un cadre convivial avec des coachs professionnels ? Notre <strong>salle de sport No Limit Fitness</strong>, située à Écrouves près de Toul, vous propose différentes activités pour vous permettre de vous défouler et de retrouver la forme dans de bonnes conditions !
              </p>
              <p className="text-gray-300 text-lg mb-8 leading-relaxed">
                Situé à côté d'une zone commerciale, notre centre de remise en forme vous accueille <strong>7 jours sur 7</strong> afin de permettre à ceux et celles qui travaillent beaucoup, de planifier au moins un entraînement malgré un emploi du temps chargé.
              </p>
              <Link to="/contact">
                <Button size="lg">Contactez-nous</Button>
              </Link>
            </div>
            
            <div className="grid grid-cols-2 gap-4">
              <div className="bg-zinc-900 p-6 rounded-2xl border border-white/5 text-center">
                <Clock className="h-10 w-10 text-nolimit-red mx-auto mb-4" />
                <h3 className="text-white font-bold text-lg mb-2">7j/7</h3>
                <p className="text-gray-400 text-sm">De 6h à 23h</p>
              </div>
              <div className="bg-zinc-900 p-6 rounded-2xl border border-white/5 text-center">
                <Users className="h-10 w-10 text-nolimit-red mx-auto mb-4" />
                <h3 className="text-white font-bold text-lg mb-2">Coachs Pros</h3>
                <p className="text-gray-400 text-sm">Toujours disponibles</p>
              </div>
              <div className="bg-zinc-900 p-6 rounded-2xl border border-white/5 text-center">
                <Dumbbell className="h-10 w-10 text-nolimit-red mx-auto mb-4" />
                <h3 className="text-white font-bold text-lg mb-2">Équipements Matrix</h3>
                <p className="text-gray-400 text-sm">Machines récentes</p>
              </div>
              <div className="bg-zinc-900 p-6 rounded-2xl border border-white/5 text-center">
                <MapPin className="h-10 w-10 text-nolimit-red mx-auto mb-4" />
                <h3 className="text-white font-bold text-lg mb-2">Parking Gratuit</h3>
                <p className="text-gray-400 text-sm">Pour nos adhérents</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Nos Prestations */}
      <section className="py-20 bg-zinc-900">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-black italic text-white mb-4">
              NOS <span className="text-nolimit-red">PRESTATIONS</span>
            </h2>
            <p className="text-gray-400 text-lg">Tout pour atteindre vos objectifs</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {[
              {
                icon: <Dumbbell className="h-8 w-8 text-black" />,
                title: "Musculation",
                desc: "Espace musculation complet avec machines Matrix dernière génération",
                link: "/offres"
              },
              {
                icon: <Heart className="h-8 w-8 text-black" />,
                title: "Cardio",
                desc: "Appareils cardio-training performants pour travailler votre endurance",
                link: "/offres"
              },
              {
                icon: <Users className="h-8 w-8 text-black" />,
                title: "Cours Collectifs",
                desc: "Planning varié : Yoga, Pump, HIIT, Zumba et bien plus encore",
                link: "/planning"
              },
              {
                icon: <Award className="h-8 w-8 text-black" />,
                title: "Coaching Personnalisé",
                desc: "Accompagnement sur-mesure avec nos coachs certifiés",
                link: "/app"
              }
            ].map((service, idx) => (
              <Link key={idx} to={service.link}>
                <div className="bg-black p-8 rounded-2xl border border-white/5 hover:border-nolimit-red/50 transition-all group h-full">
                  <div className="w-16 h-16 bg-nolimit-red rounded-xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform">
                    {service.icon}
                  </div>
                  <h3 className="text-xl font-bold text-white mb-3">{service.title}</h3>
                  <p className="text-gray-400 leading-relaxed">{service.desc}</p>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* Avantages Section */}
      <section className="py-20 bg-black">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-black italic text-white mb-4">
              VOS <span className="text-nolimit-red">AVANTAGES</span>
            </h2>
            <p className="text-gray-400 text-lg">Nos professionnels du fitness vous font bénéficier de nombreux avantages</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {[
              "Pas de frais d'adhésion",
              "Pas de frais de prélèvement",
              "Formule spéciale Week-end",
              "Formule au mois, trimestre ou semestre",
              "Formule annuelle à partir de 26€/mois",
              "Tarifs spéciaux pour les étudiants",
              "Parking gratuit pour nos adhérents",
              "Ouvert tous les jours, jours fériés compris",
              "Accès de 6h à 23h"
            ].map((avantage, idx) => (
              <div key={idx} className="flex items-start space-x-4 bg-zinc-900 p-6 rounded-xl border border-white/5">
                <div className="w-6 h-6 bg-nolimit-red rounded-full flex items-center justify-center shrink-0 mt-0.5">
                  <Star className="h-4 w-4 text-black fill-black" />
                </div>
                <p className="text-gray-200 font-medium">{avantage}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Localisation */}
      <section className="py-20 bg-zinc-900">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-4xl font-black italic text-white mb-6">
                VENEZ NOUS <span className="text-nolimit-red">RENCONTRER</span>
              </h2>
              <p className="text-gray-300 text-lg mb-8 leading-relaxed">
                Pour que votre pratique du sport se fasse dans des conditions optimales, notre équipe de coachs de fitness vous encadre et reste disponible pour répondre à toutes vos questions.
              </p>
              <p className="text-gray-300 text-lg mb-8 leading-relaxed">
                Venez découvrir sans plus attendre nos coachs sportifs et l'ambiance conviviale de notre club de fitness près de Toul !
              </p>
              
              <div className="space-y-4 mb-8">
                <div className="flex items-center space-x-4 text-gray-200">
                  <MapPin className="h-6 w-6 text-nolimit-red shrink-0" />
                  <div>
                    <p className="font-bold">155 Rue Robert Schumann</p>
                    <p>54200 Écrouves</p>
                  </div>
                </div>
                <div className="flex items-center space-x-4 text-gray-200">
                  <Clock className="h-6 w-6 text-nolimit-red shrink-0" />
                  <div>
                    <p className="font-bold">Ouvert 7j/7</p>
                    <p>De 6h à 23h (jours fériés compris)</p>
                  </div>
                </div>
              </div>

              <Link to="/contact">
                <Button size="lg">Nous contacter</Button>
              </Link>
            </div>
            
            <div className="h-[500px] rounded-2xl overflow-hidden border border-white/10">
              <iframe 
                src="https://www.openstreetmap.org/export/embed.html?bbox=5.8505%2C48.6745%2C5.8605%2C48.6795&layer=mapnik&marker=48.677%2C5.8555"
                className="w-full h-full"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                title="Localisation No Limit Fitness"
              />
            </div>
          </div>
        </div>
      </section>

      {/* CTA Final */}
      <section className="py-20 bg-nolimit-red">
        <div className="max-w-4xl mx-auto px-4 text-center">
          <Zap className="h-16 w-16 text-black mx-auto mb-6" />
          <h2 className="text-4xl font-black text-black mb-6 italic uppercase">
            Rejoignez-nous dès aujourd'hui !
          </h2>
          <p className="text-xl text-white/90 mb-10 font-medium">
            Découvrez notre club et profitez d'une séance d'essai gratuite
          </p>
          <Link to="/contact">
            <button className="bg-white text-nolimit-red hover:bg-gray-100 px-8 py-4 rounded-full font-bold text-lg transition-all transform hover:scale-105 shadow-xl">
              RÉSERVER MA SÉANCE GRATUITE
            </button>
          </Link>
        </div>
      </section>
    </Layout>
  );
};

export default Club;